import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { Log } from "../../interfaces/technical-letters/log.models";
import { ActivatedRoute, Router } from "@angular/router";
import { TechnicalLetterService } from "../../services/technical-letters/technical-letter.service";

@Component({
    selector: "app-letter-change-log",
    templateUrl: "./deleted-equipment-log.component.html",
    standalone: false
})
export class DeletedEquipmentLogComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = [
    "when",
    "who",
    "disposition",
    "comments",
    "assignedDate",
    "businessUnit",
    "plant",
    "equipment",
    "model",
    "shortName",
    "id",
  ];
  logs: Log[] = [];
  loading = false;
  error: string | null = null;
  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private letterTechicalService: TechnicalLetterService
  ) {}

  ngOnInit(): void {
    const letterId = Number(this.route.snapshot.paramMap.get("letterId"));
    if (letterId) {
      this.loading = true;
      this.letterTechicalService.getDeletedEquipmentLogs(letterId).subscribe({
        next: (data) => {
          this.logs = data;
          this.dataSource.data = data;
          this.error = null;
          this.loading = false;
        },
        error: (err) => {
          if (err.status === 404) {
            this.logs = [];
            this.dataSource.data = [];
            this.error = null;
          } else {
            this.error = "Failed to load deleted equipment logs.";
          }
          this.loading = false;
        },
      });
    } else {
      this.error = "No letter ID provided.";
    }
  }

  viewDeletedLogs(letterId: number) {
    this.router.navigate(["/deleted-equipment-log", letterId]);
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }
}
